const API_BASE = import.meta.env.VITE_API_URL ?? '';
const TOKEN_KEY = 'admin_token';

export async function apiFetch<T>(
  path: string,
  options: RequestInit = {}
): Promise<{ success: boolean; data: T; error?: { code: string; message: string } }> {
  const token = localStorage.getItem(TOKEN_KEY);
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  return res.json() as Promise<{
    success: boolean;
    data: T;
    error?: { code: string; message: string };
  }>;
}
